<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<script setup lang="ts">

// Provide the deployment state
provide('deploymentState', {})

</script>

<style lang="postcss">
#__nuxt {
  @apply h-full w-full;
}
</style>
